<template>
  <div class='popup-container' :id="'comment-container-'+issue.id" @click='show = !show'>
  <div class="ol-popup" :id="'comment-'+issue.id" v-if='show'>
    <p>{{issue.subject}}</p>
    <blockquote class="blockquote-footer">{{issue.author.name}}</blockquote>
    <div class="popup-toolbar">
      <div class="d-flex">
        <b-btn @click="viewIssue" variant="link" v-b-tooltip.hover.auto title="View comment in Redmine">
          <icon name="link"></icon>
        </b-btn>
        <b-btn @click="editIssue" variant="link" v-b-tooltip.hover.auto title="Edit Comment">
          <icon name="edit"></icon>
        </b-btn>
        <b-btn @click="deleteIssue" variant="link" v-b-tooltip.hover.auto title="Remove Comment">
          <icon name="times"></icon>
        </b-btn>
      </div>
    </div>
    </div>
  </div>

</template>
<script>
  import 'vue-awesome/icons/edit'
  import 'vue-awesome/icons/times'
  import 'vue-awesome/icons/link'
  import store from '../../store'

  export default {
    name: 'popup',
    props: {
      issue: {
        default: null
      }
    },
    data() {
      return {
        show: false
      }
    },
    methods: {
      editIssue () {
        store.commit('map/currentCommentIssue', this.issue)
      },
      deleteIssue () {
        this.issue.delete = true
        store.commit('map/currentCommentIssue', this.issue)
      },
      viewIssue () {
        this.issue.view = true
        store.commit('map/currentCommentIssue', this.issue)
      }
    }
  }
</script>
<style lang="scss">
  .popup-toolbar {
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;

    button.btn {
      padding: 0.3rem !important;
    }
  }

  .popup-toolbar-hidden {

    button.btn {
      padding: 0.3rem !important;
    }
  }

  #comment-show-label {
    display: inline;
  }

  .popup-container {
    background: rgba(0, 0, 0, 0);
    width: 20px;
    height: 20px;
    position: relative;
    right: 10px;
    bottom: 10px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/Popup.vue